<template>
    <Layout data-step="order" class="order order-flight">
        <home-order-client-data />
    </Layout>
</template>

<script>
import Layout from '@/views/home/layout.vue';
import HomeOrderClientData from "@/views/home/components/HomeOrderClientData.vue";

export default {
    components: { Layout, HomeOrderClientData },
}
</script>
